export default __webpack_public_path__ + "static/media/iron.a5aae85c490c3973511efa4256b34296.svg";